var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('input',{attrs:{"type":"checkbox","id":_vm.uniqueId,"name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.uniqueId,"checked":_vm.isChecked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{class:{deleted: _vm.deleted},attrs:{"for":_vm.uniqueId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e9027f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ListCheckboxInput.vue
// module id = 2C4Q
// module chunks = 0